import CrudService from '@/api/CrudService';
import type { ProxySource } from '@/types/order/proxy';
import type { ApiResponse } from '@/types/common/response';

class ProxySourceService extends CrudService<ProxySource> {
  constructor() {
    super('order/proxy-sources');
  }

  metadata(): Promise<ApiResponse<any>> {
    return this.$http.get(`/${this.resource}/meta`);
  }

  regions(provider?: string): Promise<ApiResponse<any>> {
    const params = provider ? { provider } : {};
    return this.$http.get(`/${this.resource}/regions`, { params });
  }

  test(id: string | number): Promise<ApiResponse<any>> {
    return this.$http.post(`/${this.resource}/${id}/test`);
  }

  testFetch(id: string | number, options: Record<string, any>): Promise<ApiResponse<any>> {
    return this.$http.post(`/${this.resource}/${id}/test-fetch`, { options });
  }

  generateLink(id: string | number, options: Record<string, any>): Promise<ApiResponse<any>> {
    return this.$http.post(`/${this.resource}/${id}/generate-link`, { options });
  }

  balance(id: string | number): Promise<ApiResponse<any>> {
    return this.$http.get(`/${this.resource}/${id}/balance`);
  }

  balances(ids: (string | number)[] = []): Promise<ApiResponse<any>> {
    return this.$http.post(`/${this.resource}/balances`, { ids });
  }
}

export default new ProxySourceService();
